import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=6a7fcc88&scoped=true&"
import script from "./PasswordForm.vue?vue&type=script&lang=js&"
export * from "./PasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7fcc88",
  null
  
)

export default component.exports